moduleViewApp.controller('newModuleCtrl', ['$scope', '$routeParams', '$location', '$window', 'myPartnersService', 'SetsResource', 'CreateService', 'CategoriesResource', 'LanguagesResource', 'UserManager', ($scope, $routeParams, $location, $window, myPartnersService, SetsResource, CreateService, CategoriesResource, LanguagesResource, UserManager) ->
  window.debug = window.debug || {}
  window.debug["newModuleCtrl"] = $scope

  MAX_DESCRIPTION_CHAR = 1500

  _.assignIn $scope, {
    module:
      name: ""
      description: ""
      image: null
      learn_version: parseInt($routeParams.version || 3)
    currentStep: 'basic_setup'
    categories: []
    languages: []
    characterLeft: MAX_DESCRIPTION_CHAR
    invite_emails: []
    collaborators: []

    CreateService: CreateService
    UserManager: UserManager

    isLanguage: ->
      $scope.category.title == 'Languages'

    subCategoryText: ->
      if $scope.category && $scope.isLanguage()
        "js.module_view.edit_module.subcategory_language"
      else
        "js.module_view.edit_module.subcategory"

    contentLanguageText: ->
      if $scope.category && $scope.isLanguage()
        "js.module_view.edit_module.category_language"
      else
        "js.module_view.edit_module.category"

    isValid: (step) ->
      switch step || $scope.currentStep
        when 'basic_setup'
          $scope.module.name && $scope.module.name.length > 1
        when 'categorization'
          !!($scope.category?.id && $scope.language?.id && ($scope.subject?.id  || !$scope.isLanguage()))
        else
          uploaderBusy = _.find $scope.imageUploaders, (uploader) -> uploader.imageUpload.active
          !uploaderBusy && !$scope.dirty

    nextStep: ->
      switch $scope.currentStep
        when 'basic_setup'
          $scope.currentStep = 'categorization'
        when 'categorization'
          $scope.currentStep = 'design'
        else
          $scope.dirty = true
          params = _.assignIn $scope.module,
            category_id: $scope.category.id
            language_id: $scope.language.id
            icon_image_id: $scope.module.image && $scope.module.image.id
            subject_id: $scope.subject && $scope.subject.id
            partner_id: $scope.partner && $scope.partner.id
            description_html: $scope.module.description_html

          if $scope.set
            params.set_id = $scope.set.id

          CreateService.resource.create {}, params, (result) ->
            $window.location.href = CreateService.path($scope.module.learn_version)(result.response.id)

    updateModuleCategories: ->
      if $scope.module.main_category
        $scope.category = _.find($scope.categories,id: $scope.module.main_category.id)
      if $scope.category && $scope.module.subcategory
        $scope.subject = _.find($scope.category.children,id: $scope.module.subcategory.id)

    updateModuleLanguage: ->
      $scope.language = _.find($scope.languages,id: $scope.module.language.id)
  }

  if $routeParams.set_id
    $scope.dirty = true
    SetsResource.get { id: $routeParams.set_id }, (success) ->
      $scope.set = success.response
      $scope.module.name = $scope.set.name + " Series"
      _.assignIn $scope.module, _.pick($scope.set, ["description", "main_category", "subcategory", "language", "image", "learn_version"])

      if $scope.categories
        $scope.updateModuleCategories()
      if $scope.languages
        $scope.updateModuleLanguage()

      $scope.dirty = false

  CategoriesResource.get {}, (success) ->
    $scope.categories.push
      title: "-- No category selected"
    $scope.category = $scope.categories[0]
    $scope.categories = $scope.categories.concat(_.find(success.response, slug: "content-categories").children)
    if $scope.module.main_category
      $scope.updateModuleCategories()

  LanguagesResource.query {}, (success) ->
    $scope.languages.push
      english_name: "-- No language selected"
    $scope.language = _.find $scope.languages, (l) -> l.code == "en"
    $scope.languages = $scope.languages.concat(success.response)
    if $scope.module.language
      $scope.updateModuleLanguage()

  myPartnersService.initialize().then () ->
    $scope.partner = myPartnersService.currentProductPartner

  $scope.$watch "module.description_html", ->
    $scope.module.description_html ||= ""
    $scope.characterLeft = MAX_DESCRIPTION_CHAR - $scope.module.description_html.length
    $scope.module.description_html = $scope.module.description_html.substring(0, MAX_DESCRIPTION_CHAR)

  $scope.$watch "languages", ->
    if $scope.languages && !$scope.language
      $scope.language = _.find $scope.languages, (l) -> l.code == "en"


])
